/* ============================================================
   ARTIKEL TUTORIAL — gaya + penukar pautan (dikongsi)
   ============================================================
   Dua benda ini dipakai oleh TIGA fail: pemapar artikel, editor
   artikel, dan halaman lesson (untuk kad teks rupa lama). Ia duduk
   dalam fail SENDIRI kerana peraturan lint projek (`react-refresh/
   only-export-components`) melarang satu fail mengeksport komponen
   dan bukan-komponen serentak — dan `pautkanTeks` memulangkan JSX,
   jadi failnya wajib `.jsx`, bukan `.js`.

   ⛔ Jangan salin mana-mana daripadanya ke dalam fail pemanggil.
      Peraturan pautan yang berbeza antara kad teks lama dan artikel
      bergambar akan kelihatan seperti pepijat kepada pelanggan.
   ============================================================ */

/* Lebar bacaan ~760px. Baris yang lebih lebar memaksa mata berjalan
   jauh dan pembaca hilang tempat bila turun baris — piawai sama
   dipakai laman kursus. */
export const GAYA_ARTIKEL = `
.art { max-width: 760px; }

.art-lead { font-size:16px; line-height:1.7; color:var(--s-ink-2); margin:0 0 18px; white-space:pre-wrap; overflow-wrap:anywhere; }
.art-meta { display:flex; flex-wrap:wrap; align-items:center; gap:16px; padding:12px 0 0;
            border-top:1px solid var(--s-line); font-size:13px; color:var(--s-ink-3); }
.art-meta span { display:inline-flex; align-items:center; gap:6px; }

.art-kad { border:1px solid var(--s-line); border-radius:var(--s-r-lg); background:var(--s-card); padding:20px 22px; margin:26px 0; }
.art-kad__t { font-size:11px; font-weight:700; letter-spacing:.09em; text-transform:uppercase; color:var(--s-ink-3); margin-bottom:12px; }

.art-semak { list-style:none; margin:0; padding:0; display:grid; gap:10px; }
.art-semak li { display:flex; gap:10px; font-size:14.5px; line-height:1.6; color:var(--s-ink-2); }
.art-semak svg { flex:none; margin-top:3px; color:var(--s-ink); }

.art-toc { list-style:none; margin:0; padding:0; display:grid; gap:2px; counter-reset:toc; }
.art-toc a { display:flex; gap:12px; padding:7px 8px; margin:0 -8px; border-radius:9px; text-decoration:none;
             font-size:14.5px; color:var(--s-ink-2); transition:background .12s ease, color .12s ease; }
.art-toc a:hover { background:var(--s-fill); color:var(--s-ink); }
.art-toc a::before { counter-increment:toc; content:counter(toc); flex:none; width:20px; color:var(--s-ink-3);
                     font-variant-numeric:tabular-nums; font-size:13px; }

.art-h2 { font-size:23px; line-height:1.3; font-weight:600; letter-spacing:-.01em; color:var(--s-ink);
          margin:36px 0 8px; padding-top:36px; border-top:1px solid var(--s-line); scroll-margin-top:20px; }
.art-p { font-size:15.5px; line-height:1.75; color:var(--s-ink-2); margin:0 0 16px;
         white-space:pre-wrap; overflow-wrap:anywhere; }

.art-langkah { list-style:none; margin:0 0 18px; padding:0; counter-reset:lang; display:grid; gap:16px; }
.art-langkah > li { position:relative; padding-left:42px; font-size:15.5px; line-height:1.7; color:var(--s-ink-2);
                    white-space:pre-wrap; overflow-wrap:anywhere; }
.art-langkah > li::before { counter-increment:lang; content:counter(lang); position:absolute; left:0; top:-1px;
    width:27px; height:27px; border-radius:99px; display:grid; place-items:center;
    background:var(--s-primary); color:var(--s-primary-ink); font-size:13px; font-weight:650;
    font-variant-numeric:tabular-nums; }

.art-gbr { margin:22px 0; }
.art-gbr img { display:block; width:100%; height:auto; border-radius:var(--s-r-lg); border:1px solid var(--s-line); }
.art-gbr__kosong { aspect-ratio:16/9; border:1px dashed var(--s-line-strong); border-radius:var(--s-r-lg);
                   background:var(--s-fill); display:grid; place-items:center; text-align:center; padding:22px;
                   font-size:13.5px; line-height:1.6; color:var(--s-ink-3); }
.art-gbr__cap { margin-top:9px; font-size:13px; line-height:1.6; color:var(--s-ink-3); }

.art-nota { display:flex; gap:12px; padding:15px 17px; margin:20px 0; border-radius:var(--s-r);
            background:var(--s-fill); border-left:3px solid var(--s-ink-3); }
.art-nota svg { flex:none; margin-top:2px; color:var(--s-ink-2); }
.art-nota--amaran { border-left-color:var(--s-warn); }
.art-nota--amaran svg { color:var(--s-warn); }
.art-nota--stop { border-left-color:var(--s-stop); }
.art-nota--stop svg { color:var(--s-stop); }
.art-nota__b { font-size:14.5px; line-height:1.7; color:var(--s-ink-2); white-space:pre-wrap; overflow-wrap:anywhere; }
.art-nota__t { display:block; font-weight:600; color:var(--s-ink); margin-bottom:3px; }

.art-jad { width:100%; border-collapse:collapse; margin:20px 0; font-size:14.5px; }
.art-jad th, .art-jad td { text-align:left; padding:11px 14px; border-bottom:1px solid var(--s-line);
                           vertical-align:top; white-space:normal; line-height:1.6; }
.art-jad th { font-size:11px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:var(--s-ink-3); }
.art-jad td:first-child { color:var(--s-ink); font-weight:500; width:34%; }
.art-jad td { color:var(--s-ink-2); }

.art-sj { display:grid; gap:2px; margin:20px 0; }
.art-sj details { border-bottom:1px solid var(--s-line); }
.art-sj summary { cursor:pointer; list-style:none; padding:14px 2px; font-size:15px; font-weight:500;
                  color:var(--s-ink); display:flex; align-items:center; gap:10px; }
.art-sj summary::-webkit-details-marker { display:none; }
.art-sj summary::after { content:"+"; margin-left:auto; color:var(--s-ink-3); font-size:17px; line-height:1; }
.art-sj details[open] summary::after { content:"–"; }
.art-sj p { margin:0 0 15px; font-size:14.5px; line-height:1.7; color:var(--s-ink-2);
            white-space:pre-wrap; overflow-wrap:anywhere; }

@media (max-width: 700px) {
  .art-h2 { font-size:20px; }
  .art-jad td:first-child { width:42%; }
}
`;

/* ⭐ URL dalam teks jadi PAUTAN hidup (arahan user 2026-08-23) — nota
   lesson kerap membawa link (borang, Gem/GPT, halaman rujukan) dan
   sebelum ini pelanggan terpaksa salin-tampal manual. Teks dipecah
   kepada nod React, BUKAN dangerouslySetInnerHTML — kandungan kekal
   TEPAT seperti ditaip (peraturan pre-wrap masih terpelihara,
   salin-tampal memulangkan teks yang sama) dan tiada HTML dari doc
   tutorial boleh terselit masuk. Tanda baca di HUJUNG url (titik/koma
   penutup ayat) dikekalkan sebagai teks biasa — kalau tidak, link
   dalam ayat seperti "…/borang." membawa titik itu dan jadi 404. */
const URL_DALAM_TEKS = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

export function pautkanTeks(teks) {
    /* split dengan kumpulan tangkapan → indeks GANJIL sentiasa URL. */
    return String(teks).split(URL_DALAM_TEKS).map((p, i) => {
        if (i % 2 === 0 || !p) return p;
        const ekor = (p.match(/[.,;:!?)\]'"”»]+$/) || [''])[0];
        const url = ekor ? p.slice(0, -ekor.length) : p;
        if (!url) return p;
        return (
            <span key={i}>
                <a
                    href={/^www\./i.test(url) ? `https://${url}` : url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'var(--s-ink)', textDecoration: 'underline', textUnderlineOffset: 3 }}
                >{url}</a>
                {ekor}
            </span>
        );
    });
}
